import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = { class: "space-y-10" }
const _hoisted_3 = { class: "space-y-4 sm:space-y-5 text-left" }
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { class: "text-black font-semibold leading-tight text-[2rem] sm:text-[2.6rem] md:text-[3.4rem] lg:text-[4rem]" }
const _hoisted_6 = { class: "text-black font-semibold leading-tight text-[2rem] sm:text-[2.6rem] md:text-[3.4rem] lg:text-[4rem]" }
const _hoisted_7 = { class: "text-[#627282] font-medium leading-[1.25] sm:leading-[1.35] md:leading-[1.45] text-[12px] sm:text-[12px] md:text-[14px] max-w-[36rem] sm:max-w-[52rem] lg:mt-10" }
const _hoisted_8 = { class: "pt-2 sm:pt-4" }

import LayoutSection from "@/components/design/layoutSection.vue";
import SearchCommonSection from "@/components/search/searchCommonSection.vue";
import { useRouter } from "vue-router";
import { useIntroSection } from "./useIntroSection";


export default /*@__PURE__*/_defineComponent({
  __name: 'introSection',
  setup(__props) {

const {
  filters,
} = useIntroSection();

const router = useRouter();

const popularSearches = [
  { label: "Medicina funcional", therapy: "functional-medicine" },
  { label: "Nutrición", therapy: "nutrition" },
  { label: "Terapia neural", therapy: "neural-therapy" },
  { label: "Acupuntura", therapy: "acupuncture" },
  { label: "Breathwork", therapy: "breathwork" },
];

function handleChipSearch(chip: { label: string; therapy: string }) {
  router.push({
    path: "/search",
    query: {
      online: "1",
      inPerson: "1",
      therapy: chip.therapy,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutSection, {
    paddingClass: "pt-12 sm:pt-12 md:pt-12 lg:pt-32 pb-12 sm:pb-14 md:pb-14 lg:pb-20",
    sectionClass: "mt-[2.5rem] sm:mt-[2.5rem] md:mt-[2.5rem] lg:mt-[4rem]"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("seoHomeH1")), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, " \"" + _toDisplayString(_ctx.$t("Functional medicine treats the person as a whole")) + ": " + _toDisplayString(_ctx.$t("mind, body, and spirit")) + "\" ", 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("- Andrew Weil")), 1)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t(
              "Find and book appointments with your healthcare professional or join their classes, one-off sessions, and experiences.",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(SearchCommonSection, {
            modelValue: _unref(filters),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filters) ? (filters).value = $event : null))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})